import { Button } from "@/components/ui/button";
import { WORKSPACE_PAGE_SIZE } from "./workspace-search";

export function WorkspacePagination({
  offset,
  total,
  pending,
  onChange,
}: {
  offset: number;
  total: number;
  pending: boolean;
  onChange: (offset: number) => void;
}) {
  return (
    <div className="flex flex-wrap items-center justify-between gap-3 border-t px-4 py-3">
      <p className="text-sm text-muted-foreground" aria-live="polite">
        {total === 0
          ? "No results"
          : `${offset + 1}–${Math.min(offset + WORKSPACE_PAGE_SIZE, total)} of ${total}`}
      </p>
      <div className="flex gap-2">
        <Button
          variant="outline"
          size="sm"
          disabled={pending || offset === 0}
          onClick={() => onChange(Math.max(0, offset - WORKSPACE_PAGE_SIZE))}
        >
          Previous
        </Button>
        <Button
          variant="outline"
          size="sm"
          disabled={pending || offset + WORKSPACE_PAGE_SIZE >= total}
          onClick={() => onChange(offset + WORKSPACE_PAGE_SIZE)}
        >
          Next
        </Button>
      </div>
    </div>
  );
}
